import { t } from "../../i18n";
import { CasinoPageSeoSaveFailureCodeType } from "./casinoPageSeoDraft";
import { isSeoSaveError } from "./seoDraftStore";

function saveFailureReason(code: CasinoPageSeoSaveFailureCodeType): string {
  switch (code) {
    case "tab-count-mismatch":
      return t("admin.seo.failure.tab-count-mismatch", undefined, "the saved page has a different number of tabs than was submitted");
    case "page-without-id":
      return t("admin.seo.failure.page-without-id", undefined, "the saved page has no id");
    case "tab-order-mismatch":
      return t("admin.seo.failure.tab-order-mismatch", undefined, "the saved page's tabs could not be matched to the submitted tabs");
    case "tab-missing":
      return t("admin.seo.failure.tab-missing", undefined, "a submitted tab is missing from the saved page");
    case "invalid-og-image-url":
      return t(
        "admin.seo.failure.invalid-og-image-url",
        undefined,
        "a social share image URL is not a valid http(s) address; correct the highlighted field and save again",
      );
  }
}

/** The reason shown to the operator when loading or saving casino SEO failed. */
export function seoFailureReason(error: unknown): string {
  if (isSeoSaveError<CasinoPageSeoSaveFailureCodeType>(error)) {
    return saveFailureReason(error.code);
  }
  // The SEO endpoints answer a rejected save with a plain-text reason, which HttpService passes on as the message.
  const message = (error as { message?: unknown } | undefined)?.message;
  return typeof message === "string" && message !== "" ? message : t("admin.seo.failure.unknown", undefined, "unknown error");
}
